/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.admin_sales.init());


App.admin_sales = {

  init() {
    return $(document)
      .off("change", ".js-cta-needed", this.cta_changed)
      .on("change", ".js-cta-needed", this.cta_changed)

      .off("change", ".js-merchant-agreement", this.merchant_agreement_changed)
      .on("change", ".js-merchant-agreement", this.merchant_agreement_changed);
  },


  cta_changed(evt) {
    if (this.checked) {
      return $(".js-cta-fields").fadeIn();
    } else {
      return $(".js-cta-fields").fadeOut();
    }
  },


  merchant_agreement_changed(evt) {
    if (this.checked) {
      return $(".js-merchant-agreement-fields").fadeIn();
    } else {
      return $(".js-merchant-agreement-fields").fadeOut();
    }
  }
};
